import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeColor } from '../traitTypes/TraitTypeColor';
import { TraitTypeImg } from '../traitTypes/TraitTypeImg';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { sortByFunc } from '../../../utils/helper/lodash_replacements';
import { str_replace } from '../../../utils/helper/helper_string';
import { TraitTypeTextarea } from '../traitTypes/TraitTypeTextarea';
export class TraitRegistryCssBackground extends TraitRegistryCategory {
    label = 'Background';
    constructor(parent) {
        super(parent);
        super.init();
    }
    background = () => new TraitTypeSelectWithPreview({
        /* label: 'Hintergrund',
              select: [['custom'], ['green'], ['border-box red']],
              init: 'custom',
  
              aspectsTemplate: {
                core: [
                  'backgroundImage',
                  'backgroundLinarGradient',
                  'backgroundPosition',
                  'backgroundSize',
                  'backgroundRepeat',
                  'backgroundOrigin',
                  'backgroundClip',
                  'backgroundAttachment',
                  'backgroundColor'
                ]
              },*/
        css({ at }) {
            if (at.trait.value !== 'custom') {
                // cssPairs.unshift({ k: 'background', v: at.trait.value });
                return [{ k: 'background', v: at.trait.value }];
            }
            const cssPairs = at.core.aspectCss.cssKVPairs.slice();
            return cssPairs;
        },
    });
    backgroundImage = new TraitTypeImg({
        //  label: '(Hintergrund)Bild',
        css: ({ at }) => [{ k: at.key, v: `url(${(at.attachedValue && at.attachedValue.src) || ''})` }],
        key: 'backgroundImage',
        creates: ['backgroundSize'],
        createTraits: () => [{ key: 'backgroundSize', value: '100% 100%' }],
    });
    backgroundPosition = () => new TraitTypeSelectWithPreview( /*{
      default: 'left top'
    label: 'Hintergrundposition',
    select: [
      ['left top', 'links oben'],
      ['center center', 'Mitte'],
      ['left center', 'links mitte'],
      ['left bottom', 'links unten'],
      ['right top', 'rechts oben'],
      ['10% 10%'],
      ['50px 50px'],
      ['right center', 'rechts mitte'],
      ['right bottom', 'rechts unten'],
      ['center top', 'mitte oben'],
      ['center bottom', 'mitte unten']
    ]
    }*/);
    backgroundBlendMode = () => new TraitTypeSelectWithPreview( /*{
    label: 'Hintergrund Blending',
    select: [
   ['normal'],
      ['multiply'],
      ['screen'],
      ['overlay'],
      ['darken'],
      ['lighten'],
      ['color-dodge'],
      ['color-burn'],
      ['hard-light'],
      ['soft-light'],
      ['difference'],
      ['exclusion'],
      ['hue'],
      ['saturation'],
      ['color'],
      ['luminosity'],
    ]
    }*/);
    backgroundSize = () => new TraitTypeSelectWithPreview( /*{
      default: 'auto',
      init:
        '100% 100%'
      label: 'Hintergrundgröße',
      select: [
        ['100% 100%', 'passend'],
        ['auto', 'Seitenverhältnis beibehalten, skalieren'],
        ['cover', 'Seitenverhältnis beibehalten, so klein wie möglich aber vollständig abdecken,'],
        ['contain', 'Seitenverhältnis beibehalten, so groß wie möglich, aber enthalten'],
        ['auto auto'],
        ['100px 100px'],
        ['50% 50%'],
        ['25%'],
        ['0%'],
        ['inherit']
      ]
    }*/);
    backgroundRepeat = () => new TraitTypeSelectWithPreview( /*{
      default:
        'repeat'
      label: 'Hintergrund Wdh.',
      select: [['repeat', 'ja'], ['no-repeat', 'nein'], ['repeat-x', 'nur →'], ['repeat-y', 'nur ↓']]
    }*/);
    backgroundOrigin = () => new TraitTypeSelectWithPreview( /*{
      default:
        'padding-box'
      label: 'Bereich des Hintergrundbildes',
      select: [
        ['padding-box', 'relativ zum padding'],
        ['border-box', 'relativ zum Rahmen'],
        ['content-box', 'relativ zum Inhalt']
      ]
    }*/);
    backgroundClip = () => new TraitTypeSelectWithPreview( /*{
      default:
        'border-box'
      label: 'Hintergrund abschneiden',
      select: [
        ['border-box', 'bis zur äußeren Ecke des Rahmens'],
        ['padding-box', 'kein Hintergrund unterhalb des Rahmens gezeichnet'],
        ['content-box', 'innerhalb des Inhalts']
      ]
    }*/);
    backgroundAttachment = () => new TraitTypeSelectWithPreview( /*{
      default: 'scroll',
        init:
            'fixed'
      label: 'Hintergrund Fest',
      select: [
        ['scroll', 'Hintergrundbild wandert beim Scrollen mit'],
        ['fixed', 'Hintergrundbild ist an einem festen Ort fixiert'],
        ['local', 'lokal']
      ]
    }*/);
    backgroundColor = () => new TraitTypeColor({
        css: ({ at }) => {
            const isStageOuter = (at.aspect.readableIdentifier.includes('stage') && at.aspect.readableIdentifier.includes('outer')) ||
                (at.actor.aspect &&
                    at.actor.aspect.readableIdentifier.includes('stage') &&
                    at.actor.aspect.readableIdentifier.includes('outer'));
            if (isStageOuter) {
                return [
                    {
                        k: 'backgroundImage',
                        v: `url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" height="100" width="100" preserveAspectRatio="none"><rect width="100%" height="100%" fill="${str_replace('#', '%23', at.trait.value)}" /></svg>')`,
                    },
                    {
                        k: 'backgroundSize',
                        v: '100% 100%',
                    },
                ];
            }
            return [
                {
                    k: 'backgroundColor',
                    v: at.trait.value,
                },
            ];
        },
    } /*{ label: 'Hintergrundfarbe' }*/);
    backgroundLinarGradient = () => new TraitTypeSelectWithPreview({
        css: ({ at }) => {
            if (at.trait.value !== 'custom') {
                return [{ k: 'backgroundImage', v: `linear-gradient(${at.trait.value})` }];
            }
            return [
                {
                    k: 'backgroundImage',
                    v: `linear-gradient(${at.valueOf.gradientAngle}, ${at.activesOf.colorStop
                        .concat()
                        .sort(sortByFunc(at => at.valueOf.colorStopMark))
                        .map((at) => `${at.trait.value} ${at.valueOf.colorStopMark}%`)
                        .join(',')})`,
                },
            ];
        } /*,
        aspectsTemplate: {
          core: ['gradientAngle', 'colorStop']
        } */,
    });
    backgroundInlineSvg = () => 
    // Converter: https://www.kmhcreative.com/downloads/CSS2SVG.htm
    new TraitTypeTextarea({
        css: ({ at }) => {
            return [
                {
                    k: 'backgroundImage',
                    v: `url('data:image/svg+xml;utf8,${str_replace('\n', '', str_replace(`'`, `"`, str_replace('#', '%23', at.trait.value)))}')`,
                },
                ,
                {
                    k: 'backgroundSize',
                    v: '100% 100%',
                },
            ];
        },
    });
    gradientAngle = () => new TraitTypeSelectWithPreview({
        //  hidden: true,
        default: '0deg',
        css: () => [] /*
        label: 'Richtung Winkel',
        select: [
          ['0deg', 'bottom to top'],
          ['90deg', 'left to right'],
          ['180deg', 'top to bottom'],
          ['270deg', 'right to left']
        ] */,
    });
    colorStop = () => new TraitTypeColor({
        default: 'red',
        css: () => [],
        multiple: true,
        /* hidden: true,
              label: 'Farbstop',
              aspectsTemplate: {
                core: ['colorStopMark']
              } */
    });
    colorStopMark = () => new TraitTypeNumericWithSlider({
        default: 0,
        css: () => [],
        /*  hidden: true,
              label: 'Marke',
              min: -200,
              max: 300, */
    });
}
